// extracted by mini-css-extract-plugin
module.exports = {"wrap":"input-toggle_wrap__Alnnr","isActive":"input-toggle_isActive__f933g","knob":"input-toggle_knob__F1Pgm","label":"input-toggle_label__pd_d7"};